import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import ExportSpreadsheet from "./ExportSpreadSheet";
import { usePromiseTracker } from "react-promise-tracker";
import { HashLoader } from "react-spinners";

const useStyles = makeStyles((theme) => ({
  paper: {
    textAlign: "center",
    minHeight: "2vh",
    "&:hover": {
      backgroundColor: theme.palette.primary.light,
      cursor: "pointer",
    },
    numberOfResult: {
      marginBottom: theme.spacing(2),
    },
  },
  result_container: {
    position: "relative",
  },
  result_title: {
    // position: "fixed",
    // paddingTop: "5px",
    // backgroundColor: "#ffffff",
  },
  result: {
    // position: "fixed",
    // top: 0,
    paddingTop: "5px",
    paddingLeft: "3px",
    paddingRight: "5px",
    paddingBottom: "3px",
    // maxHeight: "80vh",
    // overflow: "auto",
    // overflowX: "hidden",
  },
  progress: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    alignItems: "center",
  },
}));

function Search(props) {
  const classes = useStyles();
  const { promiseInProgress } = usePromiseTracker();
  const [filteredData, setFilteredData] = useState([]);
  const [requestedCase, setRequestedCase] = useState(null);

  const handleOpen = (e, donorCase) => {
    props.setCurrentCase(donorCase);
    props.setDialogue(true);
  };

  useEffect(() => {
    setFilteredData(filtering());
  }, [props]);

  useEffect(() => {
    if (typeof props.requestedCaseId !== "undefined") {
      setRequestedCase(
        filteredData.filter(
          (donor) => donor.case_id === props.requestedCaseId,
        )[0],
      );
    }
  }, [props.requestedCaseId, filteredData]);

  useEffect(() => {
    if (typeof requestedCase !== "undefined" && requestedCase !== null) {
      props.setCurrentCase(requestedCase);
      props.setDialogue(true);
    }
  }, [requestedCase]);

  const filtering = () =>
    props.rawData
      // public case only
      .filter((donor) => donor.is_public === 1)
      // Cohort
      .filter(
        (donor) =>
          (donor.case_id !== null &&
            ((donor.case_id.startsWith("HDL") && props.handelpCohortChecked) ||
              (!donor.case_id.startsWith("HDL") && props.npodCohortChecked))) ||
          props.cohortEnable === false,
      )
      // Case ID
      .filter((donor) => {
        if (props.selectedCaseId.length > 0 && props.caseIDEnable) {
          if (
            props.selectedCaseId
              .map((obj) => obj.value)
              .indexOf(donor.case_id) > -1
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      })
      // Donor type
      .filter((donor) => {
        if (
          donor.donor_type_id !== null &&
          props.selectedDonorType.length > 0 &&
          props.donorTypeEnable
        ) {
          const typeName = props.donorTypesMap[donor.donor_type_id];
          if (
            props.selectedDonorType.map((obj) => obj.value).indexOf(typeName) >
            -1
          ) {
            return true;
          } else {
            return false;
          }
        }
        return true;
      })
      // Age
      .filter(
        (donor) =>
          (donor.age_years !== null &&
            donor.age_years >= props.ageMin &&
            donor.age_years <= props.ageMax) ||
          props.ageEnable === false,
      )
      // Age Onset
      .filter(
        (donor) =>
          (donor.age_onset_years !== null &&
            donor.age_onset_years >= props.ageOnsetMin &&
            donor.age_onset_years <= props.ageOnsetMax) ||
          props.ageOnsetEnable === false,
      )
      // Gender
      .filter(
        (donor) =>
          (donor.sex !== null &&
            ((donor.sex === "Female" && props.femaleChecked) ||
              (donor.sex != null &&
                donor.sex === "Male" &&
                props.maleChecked))) ||
          props.genderEnable === false,
      )
      // Race
      .filter((donor) => {
        if (props.selectedRace.length > 0 && props.raceEnable) {
          if (donor.race_ethnicity !== null) {
            if (
              props.selectedRace
                .map((obj) => obj.value)
                .indexOf(donor.race_ethnicity) > -1
            ) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        }
        return true;
      })
      // BMI
      .filter(
        (donor) =>
          (donor.BMI !== null &&
            donor.BMI >= props.bmiMin &&
            donor.BMI <= props.bmiMax) ||
          props.bmiEnable === false,
      )
      // C-Peptide
      .filter((donor) => {
        const cPeptide = donor.C_peptide_ng_mL;
        if (props.cPeptideEnable === false) {
          return true;
        } else if (cPeptide !== null) {
          if (cPeptide.slice(0, 1) === "<" && props.cPeptideNegative === true) {
            return true;
          } else if (
            Number(cPeptide) < 0.02 &&
            props.cPeptideNegative === true
          ) {
            return true;
          } else if (
            Number(cPeptide) >= 0.02 &&
            props.cPeptidePositive === true
          ) {
            return true;
          }
        }
        return false;
      })
      // Duration of Diabetes
      .filter((donor) => {
        if (props.DDEnable === false) {
          return true;
          // Donor type specified
        } else if (
          donor.donor_type_id !== null &&
          props.selectedDonorType.length > 0
        ) {
          const typeName = props.donorTypesMap[donor.donor_type_id];
          // Diabetes cases
          if (
            typeName.includes("Diabetes") &&
            !typeName.includes("No Diabetes")
          ) {
            return (
              donor.diabetes_hx_years !== null &&
              donor.diabetes_hx_years >= props.DDMin &&
              donor.diabetes_hx_years <= props.DDMax
            );
          } else {
            return true;
          }
          // Donor type not specified
        } else {
          return (
            donor.diabetes_hx_years !== null &&
            donor.diabetes_hx_years >= props.DDMin &&
            donor.diabetes_hx_years <= props.DDMax
          );
        }
      })
      // Hb1A1c
      .filter(
        (donor) =>
          (donor.HbA1c_percent !== null &&
            donor.HbA1c_percent >= props.hMin &&
            donor.HbA1c_percent <= props.hMax) ||
          props.hEnable === false,
      )
      // AutoAntibody
      .filter(
        (donor) =>
          (((props.gadaP === true && donor.GADA_Result === "Positive") ||
            props.gadaP === false) &&
            ((props.ia2aP === true && donor.IA_2A_Result === "Positive") ||
              props.ia2aP === false) &&
            ((props.miaaP === true && donor.mIAA_Result === "Positive") ||
              props.miaaP === false) &&
            ((props.znt8aP === true && donor.ZnT8A_Result === "Positive") ||
              props.znt8aP === false)) ||
          props.aaEnable === false,
      )
      // AutoAntibody number
      .filter(
        (donor) =>
          (props.zeroChecked === true && donor.AAbtally === 0) ||
          (props.oneChecked === true && donor.AAbtally === 1) ||
          (props.twoChecked === true && donor.AAbtally === 2) ||
          (props.threeChecked === true && donor.AAbtally === 3) ||
          (props.fourChecked === true && donor.AAbtally === 4) ||
          props.aaPositiveEnable === false,
      )
      // Insulitis
      .filter(
        (donor) =>
          (props.insulitisPositiveChecked === true &&
            donor.histopathology !== null &&
            donor.histopathology.toLowerCase().indexOf("insulitis") !== -1) ||
          (props.insulitisNegativeChecked === true &&
            (donor.histopathology === null ||
              donor.histopathology.toLowerCase().indexOf("insulitis") ===
                -1)) ||
          props.insulitisEnable === false,
      )
      // Dataset: electron microscopy images
      .filter(
        (donor) =>
          (props.electronMicroscopyChecked === true &&
            props.emiMap[donor.case_id]) ||
          props.electronMicroscopyChecked === false ||
          props.datasetEnable === false,
      )
      // Dataset: functional assay
      .filter(
        (donor) =>
          (props.functionalAssayChecked === true &&
            (donor.glucose_insulin || donor.KCL_insulin)) ||
          props.functionalAssayChecked === false ||
          props.datasetEnable === false,
      )
      // Dataset: high res HLA
      .filter(
        (donor) =>
          (props.highResHLAChecked === true &&
            (donor.A_1 ||
              donor.A_2 ||
              donor.B_1 ||
              donor.B_2 ||
              donor.C_1 ||
              donor.C_2 ||
              donor.DRB1_1 ||
              donor.DRB1_2 ||
              donor.DQA1_1 ||
              donor.DQA1_2 ||
              donor.DQB1_1 ||
              donor.DQB1_2 ||
              donor.DPA1_1 ||
              donor.DPA1_2 ||
              donor.DPB1_1 ||
              donor.DPB1_2)) ||
          props.highResHLAChecked === false ||
          props.datasetEnable === false,
      )
      // Dataset: immunophenotyping
      .filter(
        (donor) =>
          (props.immunophenotypingChecked === true &&
            donor.case_id in props.immunMap) ||
          props.immunophenotypingChecked === false ||
          props.datasetEnable === false,
      )
      // Dataset: Whole Exome Sequencing
      .filter(
        (donor) =>
          (props.wholeExomeSequencingAvailable === true &&
            props.geneticMap[donor.case_id]
              ?.whole_exome_sequencing_available === 1) ||
          props.wholeExomeSequencingAvailable === false ||
          props.datasetEnable === false,
      )
      // Dataset: SNPs
      .filter(
        (donor) =>
          (props.snpsAvailable === true &&
            props.geneticMap[donor.case_id]?.GRS1_score) ||
          props.snpsAvailable === false ||
          props.datasetEnable === false,
      )
      // Genetic
      .filter(
        (donor) =>
          (props?.geneticMap[donor.case_id]?.GRS1_score &&
            props.geneticMap[donor.case_id]?.GRS1_score >= props.grs1ScoreMin &&
            props.geneticMap[donor.case_id]?.GRS1_score <= props.grs1ScoreMax &&
            props?.geneticMap[donor.case_id]?.GRS2_score &&
            props.geneticMap[donor.case_id]?.GRS2_score >= props.grs2ScoreMin &&
            props.geneticMap[donor.case_id]?.GRS2_score <= props.grs2ScoreMax &&
            props?.geneticMap[donor.case_id]?.AA_GRS_score &&
            props.geneticMap[donor.case_id]?.AA_GRS_score >=
              props.aagrsScoreMin &&
            props.geneticMap[donor.case_id]?.AA_GRS_score <=
              props.aagrsScoreMax) ||
          props.geneticEnable === false,
      );
  console.log("filtered case data", filteredData);
  console.log("requested case", requestedCase);
  const currTime = new Date();
  // Time format YYYY-MM-DD_HHMMSS
  const timeStamp =
    currTime.toISOString().split("T")[0] +
    "_" +
    currTime.toTimeString().split(" ")[0].replaceAll(":", "");
  return (
    <div className={classes.result_container}>
      <div className={classes.result_title}>
        <div style={{ width: "100%" }}>
          <Box display="flex" justifyContent="space-between">
            <Box>
              <Typography variant="h4">SEARCH RESULT</Typography>
            </Box>
            <Box>
              {/* Download button */}
              <ExportSpreadsheet
                csvData={filteredData}
                fileName={"Download_From_nPOD_" + timeStamp}
              />
            </Box>
          </Box>
        </div>
        <div style={{ width: "100%" }}>
          <Box display="flex" justifyContent="flex-start">
            <Box mb={2}>
              {+(promiseInProgress === true) ? (
                <Typography variant="h6" color="secondary">
                  Loading data...
                </Typography>
              ) : (
                <Typography variant="h6" color="secondary">
                  {filteredData.length} cases are found
                </Typography>
              )}
            </Box>
          </Box>
        </div>
      </div>
      <div className={classes.result}>
        <Grid container spacing={1}>
          {filteredData.map((donorCase, index) => (
            <Grid item xs={12} sm={3} md={2} lg={1} xl={1} key={index}>
              <Paper
                elevation={3}
                onClick={(e) => handleOpen(e, donorCase)}
                className={classes.paper}
              >
                {donorCase.case_id.length <= 4 && (
                  <Typography variant="h6">{donorCase.case_id}</Typography>
                )}
                {donorCase.case_id.length > 4 && (
                  <Typography variant="subtitle1">
                    {donorCase.case_id}
                  </Typography>
                )}
              </Paper>
            </Grid>
          ))}
        </Grid>
      </div>
      <div className={classes.progress}>
        {+(promiseInProgress === true) ? (
          <HashLoader color="#4fc3f7" size={50} />
        ) : null}
      </div>
    </div>
  );
}

// Subscribe
const mapStateToProps = (state) => {
  return {
    // Age
    ageEnable: state.explore.ageEnable,
    ageRange: state.explore.ageRange,
    ageMin: state.explore.ageMin,
    ageMax: state.explore.ageMax,

    // Age Onset
    ageOnsetEnable: state.explore.ageOnsetEnable,
    ageOnsetRange: state.explore.ageOnsetRange,
    ageOnsetMin: state.explore.ageOnsetMin,
    ageOnsetMax: state.explore.ageOnsetMax,

    // Autoantibody type
    aaEnable: state.explore.aaEnable,
    gadaP: state.explore.gadaP,
    gadaN: state.explore.gadaN,
    ia2aP: state.explore.ia2aP,
    ia2aN: state.explore.ia2aN,
    miaaP: state.explore.miaaP,
    miaaN: state.explore.miaaN,
    znt8aP: state.explore.znt8aP,
    znt8aN: state.explore.znt8aN,

    // Antibody Positive
    aaPositiveEnable: state.explore.aaPositiveEnable,
    zeroChecked: state.explore.zeroChecked,
    oneChecked: state.explore.oneChecked,
    twoChecked: state.explore.twoChecked,
    threeChecked: state.explore.threeChecked,
    fourChecked: state.explore.fourChecked,

    // BMI
    bmiEnable: state.explore.bmiEnable,
    bmiRange: state.explore.bmiRange,
    bmiMin: state.explore.bmiMin,
    bmiMax: state.explore.bmiMax,

    // Diabetes Duration
    DDEnable: state.explore.DDEnable,
    DDRange: state.explore.DDRange,
    DDMin: state.explore.DDMin,
    DDMax: state.explore.DDMax,

    // Donor Type (object array)
    donorTypeEnable: state.explore.donorTypeEnable,
    selectedDonorType: state.explore.selectedDonorType,

    // Gender
    genderEnable: state.explore.genderEnable,
    maleChecked: state.explore.maleChecked,
    femaleChecked: state.explore.femaleChecked,

    // Cohort
    cohortEnable: state.explore.cohortEnable,
    npodCohortChecked: state.explore.npodCohortChecked,
    handelpCohortChecked: state.explore.handelpCohortChecked,

    // Hb1A1c
    hEnable: state.explore.hEnable,
    hRange: state.explore.hRange,
    hMin: state.explore.hMin,
    hMax: state.explore.hMax,

    // Insulitis
    insulitisEnable: state.explore.insulitisEnable,
    insulitisPositiveChecked: state.explore.insulitisPositiveChecked,
    insulitisNegativeChecked: state.explore.insulitisNegativeChecked,

    // Race
    raceEnable: state.explore.raceEnable,
    selectedRace: state.explore.selectedRace,

    // C-Peptide
    cPeptideEnable: state.explore.cPeptideEnable,
    cPeptidePositive: state.explore.cPeptidePositive,
    cPeptideNegative: state.explore.cPeptideNegative,

    // Raw Data
    rawData: state.explore.rawData,

    // Filtered Data
    filteredData: state.explore.filteredData,

    // Donor Types (map)
    donorTypesMap: state.explore.donorTypesMap,

    // Case Id
    caseIDEnable: state.explore.caseIDEnable,
    selectedCaseId: state.explore.selectedCaseId,

    // Dataset
    datasetEnable: state.explore.datasetEnable,
    functionalAssayChecked: state.explore.functionalAssayChecked,
    electronMicroscopyChecked: state.explore.electronMicroscopyChecked,
    highResHLAChecked: state.explore.highResHLAChecked,
    immunophenotypingChecked: state.explore.immunophenotypingChecked,
    wholeExomeSequencingAvailable: state.explore.wholeExomeSequencingAvailable,
    wholeExomeSequencingUnavailable:
      state.explore.wholeExomeSequencingUnavailable,
    snpsAvailable: state.explore.snpsAvailable,
    snpsUnavailable: state.explore.snpsUnavailable,

    // Electron Microscopy Images
    emiMap: state.explore.emiMap,

    // Immunophenotyping
    immunMap: state.explore.immunMap,

    // Genetic
    geneticEnable: state.explore.geneticEnable,
    grs1ScoreMin: state.explore.grs1ScoreMin,
    grs1ScoreMax: state.explore.grs1ScoreMax,
    grs1ScoreRange: state.explore.grs1ScoreRange,
    grs2ScoreMin: state.explore.grs2ScoreMin,
    grs2ScoreMax: state.explore.grs2ScoreMax,
    grs2ScoreRange: state.explore.grs2ScoreRange,
    aagrsScoreMin: state.explore.aagrsScoreMin,
    aagrsScoreMax: state.explore.aagrsScoreMax,
    aagrsScoreRange: state.explore.aagrsScoreRange,

    // Genetic Map
    geneticMap: state.explore.geneticMap,
  };
};

// update
const mapDispatchToProps = (dispatch) => {
  return {
    setRawData: (newRawData) =>
      dispatch({ type: "SET_RAW_DATA", value: newRawData }),
    setFilteredData: (newFilteredData) =>
      dispatch({ type: "SET_FILTERED_DATA", value: newFilteredData }),
    setCurrentCase: (newCase) =>
      dispatch({ type: "SET_CURRENT_CASE", value: newCase }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Search);
